<template>
  <div>
    <nav-breadcrumb :menu="[{label: '占用额度明细'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="listData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">渠道商名称：&nbsp;&nbsp;{{this.dealerName}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">占用额度：&nbsp;&nbsp;{{this.totalAmount/10000|formatMoney}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">总笔数：&nbsp;&nbsp;{{this.listData.count}}</div></el-col>
        </div>

      </data-table>
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "FinancingWithDepositList",
      data(){
        return {
          dealerId:this.$route.query['dealerId'] || '',
          dealerName:this.$route.query['dealerName'] || '',
          totalAmount:this.$route.query['totalAmount'] ||0,
          page: 1,
          pageSize: 20,
          listData: {},
          dealerOptions:[],
          filters: {
            labelWidth: '150px',
            form: {
              fi__customerName:'',
              fi__transactionNo:'',
              fi__transactionStatus:'',
            },
            columns: [
              {
                label: '贷款编号',
                component: 'el-input',
                field: 'fi__transactionNo',

              },
              {
                label: '客户姓名',
                component: 'el-input',
                field: 'fi__customerName',

              },
              {
                label: '状态',
                component: 'el-select',
                field: 'fi__transactionStatus',
                options: [
                  {
                    label: '全部',
                    value: ''
                  },
                  {
                    label: '待放款',
                    value: 'Ready'
                  },
                  {
                    label: '放款中',
                    value: 'Paying'
                  },
                  {
                    label: '还款中',
                    value: 'Processing'
                  },
                  {
                    label: '已还清',
                    value: 'Settled'
                  }
                ],
                op: 'eq',
                span: 8
              },
            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          },
          actions: [
            /*{
              label: '缴纳',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDA'
                })
              }
            },
            {
              label: '退还',
              class: 'el-button--primary',
              clickHandler: ()=>{
                this.$router.push({
                  path: 'addDR'
                })
              }
            }*/
          ],
        }
      },
      computed:{
        columns: function(){
          return [
            {
              type: 'index'
            },
            {
              label: '贷款编号',
              field: 'fi__transactionNo',

            },
            {
              label: '客户名称',
              field: 'fi__customerName',

            },
            /*{
              label: '渠道商',
              field: 'd__dealerName'
            },*/
            {
              label: '贷款金额',
              field: 'fi__totalAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '贷款利率',
              field: 'fi__interestRate',
              formatter: function (r,c,v) {
                return v +'% (' +  Status2CN(r.fi__interestType)+')'
              }
            },
            {
              label: '开始日期',
              field: 'fi__startDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '结束日期',
              field: 'fi__endDate',
              formatter: function (r,c,v) {
                return moment(v).format('YYYY-MM-DD')
              }
            },
            {
              label: '货款余额',
              field: 'fi__balanceAmount',
              formatter: function (r,c,v) {
                return formatMoney(v)
              }
            },
            {
              label: '状态',
              field: 'fi__transactionStatus',
              formatter: function (r,c,v) {
                return Status2CN('Financing_'+v)
                return v== 'Processing' && ( moment(r.fi__endDate).valueOf() < moment().valueOf() )? '已逾期' : Status2CN('Financing_'+ v)
              }
            },
          ]
        },
        filterParams: {
          get: function() {
            return {
              pageSize:0,
              'xlist.search.dfi.dealerId' : this.dealerId,
              'xlist.search.dfi.dealerId.op' : 'in',
              'xlist.sort.dataField': 'fi.endDate',
              'xlist.sort.order': 'desc'
            }
          },
          set:function (newVal) {

          }
        }
      },
      watch: {
        filterParams: function () {
          this.getData()
        },
      },
      mounted(){
        this.getData()
      },
      methods:{
        getData: function () {
          xhr.getFinancingWithDepositList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res => {
              try {
                this.listData = res.data
                this.totalAmount = 0
                this.listData.data.forEach(item=>{
                  this.totalAmount =  this.totalAmount + parseFloat( item.fi__balanceAmount)*10000
                })
              } catch (e) {

              }
            })
        },

      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/FinancingWithDepositList.vue